// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yNK3","top":"styles_top__rOknQ","left":"styles_left__2Uakf","description":"styles_description__cY3dH"};